import React from 'react';
import { Grid } from '@material-ui/core';
import WorkflowInfoCard from '../cards/WorkflowInfoCard';
import WorkflowStatusCard from '../cards/WorkflowStatusCard';
import WorkflowVersionCard from '../cards/WorkflowVersionCard';
import { BaseWorkflowTabProps } from '../Workflow.interface';

const WorkflowTabInfo: React.FC<BaseWorkflowTabProps> = ({
  workflow,
  onChange
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {workflow && (
              <WorkflowInfoCard workflow={workflow} onChange={onChange} />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {workflow && <WorkflowStatusCard workflow={workflow} />}
          </Grid>
          <Grid item xs={12}>
            {workflow && <WorkflowVersionCard workflow={workflow} />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WorkflowTabInfo;
